import { AxiosResponse } from 'axios';
import { IUserTypeApi } from '../base/registration/userTypeApi';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { api } from '../base';

const baseRoute: string = 'UserType';

export class UserTypeApi extends IUserTypeApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }
}
